export default __webpack_public_path__ + "static/media/coupon_icon.addd5873.svg";